import _ from "lodash";
import featherApp from "../../feathersjs/feathersjs";
import {withErrorHandler} from "./common";
import { removeNullValue } from "./student";
import { transformSort } from "./event";

const CheckInService = featherApp.service("event-check-in");

  export const fetchAllCheckIn = withErrorHandler(async (searchData) => {
    return await CheckInService.find(searchData);
  });


  export const fetchEventCheckInByEventIdAndProfileId = withErrorHandler(async ({ eventId, profileId, params, sort }) => {
    const { current = 1, pageSize: $limit = 1000, ...requestParams } = params || {};
    const $sort = transformSort(sort) || undefined;
  
    const query = {
      query: {
        $sort,
        eventId: eventId || undefined,
        profileId: profileId || undefined,
        $or: [
          { checkIn: 'notNull' }, 
          { checkOut: 'notNull' }
        ],
        $limit,
         $skip: (current - 1) * $limit,
        ...requestParams

      }
    };

    return await fetchAllCheckIn(query);
  });

  export const updateCheckIn = withErrorHandler(async (id, data) => {
    return CheckInService.patch(id, data);
  })
  
  
  export const createCheckIn = withErrorHandler(async (data) => {
    return CheckInService.create(data);
  })

  export const fetchEventCheckInWithSearch = withErrorHandler(async ({ updatedParams, sort, filter }) => {
    removeNullValue(updatedParams);
    removeNullValue(filter);
    const $sort = transformSort(sort);
    const { current = 1, pageSize: $limit = 1000,  groupProfileId, ...requestParams } = updatedParams;
    const handleRequest = transformEventCheckInRequestParams(requestParams);
    const searchData = createSearchData( current, $limit, handleRequest, $sort, filter, groupProfileId);
    
    return fetchAllCheckIn(searchData);
  });
  
  
  const createSearchData = (current, $limit, handleRequest,$sort, filter, groupProfileId) => {
    return {
      query: {
        $sort,
        $limit,
        $skip: (current - 1) * $limit,
        groupProfileId,
        ...handleRequest,
        ...filter,
      }
    };
  };

  export const transformEventCheckInRequestParams = (requestParams) => {
    
    return _.transform(requestParams, (result, value, key) => {
      const profileKeys = ['groupId', 'firstName', 'holyName', 'profileID'];

      if (profileKeys.includes(key)) {
        result['profile'] = {
          ...result['profile'],
          [key]: value 
        };
      } 
      else if (value) {
        result[key] = value; 
      }
      return result;
    }, {});
    
  };
  